import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class Roles extends BaseAPIModel {
    fields() {
        return {
            name: '',
            id: { primaryKey: true, readOnly: true }
        };
    }

    toOption() {
        return {
            text: this.name || '-',
            value: this.slug,
            key: this.slug
        };
    }

    static listUrl(params) {
        return `/ticket/roles/`;
    }
}

export class ModerationRole extends Roles {
    static listUrl({ organizationId }) {
        return `/ticket/organizations/${organizationId}/moderation_flows/roles`;
    }
}
